import Cookies from "js-cookie";
import {ElNotification} from "element-plus";
export async function CheckUser(router){
    const token = Cookies.get('user_token');
    if(token){
        const response = await fetch('https://inv.tvcnews.co/endPoint/checkAdmin.php',{
            method:"POST",
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':'Bearer '+token
            }
        })
        const data = await response.json();
        if(data?.status===200){

           return data?.data;
        }else{
            await router.push('/signin');
            ElNotification({
                title: 'Warning',
                style:"font-family:tahoma",
                message: 'توکن ورود به حساب کاربری منقضی شده است. لطفا دوباره وارد حساب کاربری شوید',
                type: 'warning',
            })
        }
    }else{
        await router.push('/signin');
        ElNotification({
            title: 'Warning',
            style:"font-family:tahoma",
            message: 'توکن ورود به حساب کاربری منقضی شده است. لطفا دوباره وارد حساب کاربری شوید',
            type: 'warning',
        })
    }
}
export async function fetchBitcoinBidPrice() {
    const url = 'https://bitcoinaverage-global-bitcoin-index-v1.p.rapidapi.com/indices/global/ticker/BTCGBP';
    const options = {
        method: 'GET',
        headers: {
            'x-rapidapi-key': 'qC3js5c0FimshvbPYYReRiS1G7IEp1jOBYYjsnCFbM2kTHqETM',
            'x-rapidapi-host': 'bitcoinaverage-global-bitcoin-index-v1.p.rapidapi.com'
        }
    };

    try {
        const response = await fetch(url, options);
        const result = await response.json();
        return result.bid; // Return only the bid price
    } catch (error) {
        console.error(error);
        return null; // Return null in case of an error
    }
}
export async function fetchGBPtoUSDExchangeRate() {
    const url = 'https://fixer-fixer-currency-v1.p.rapidapi.com/latest?base=GBP&symbols=USD';
    const options = {
        method: 'GET',
        headers: {
            'x-rapidapi-key': 'qC3js5c0FimshvbPYYReRiS1G7IEp1jOBYYjsnCFbM2kTHqETM',
            'x-rapidapi-host': 'fixer-fixer-currency-v1.p.rapidapi.com'
        }
    };

    try {
        const response = await fetch(url, options);
        const result = await response.json();
        return result.rates.USD; // Return only the USD rate
    } catch (error) {
        console.error(error);
        return null; // Return null in case of an error
    }
}
export function NameOnDisplay(data){
    let size;
    let option;
    if(data.Size?.Group){
        size= ' - '+ data.Size?.Group
    }else{
        size='';
    }
    if(data.Option?.Name){
        if(data.Option?.Price>0){
            option=' - '+data?.Option?.Name+' £'+toCurrencyFormat(data.Option?.Price)
        }else{
            option=' - '+data?.Option?.Name
        }
    }else{
        option=''
    }
    let custom = '';
    if(data.Customisation?.length>0){
        for(let i = 0; i<data.Customisation?.length;i++){
            custom = custom+' - '+data.Customisation[i].Name +' £'+toCurrencyFormat(data.Customisation[i].Price)
        }
    }
    let sub ='';
    if(data?.PlanDiscount){
        sub= ' - Discounted %'+data?.PlanDiscount
    }else{
        sub=''
    }
    return data.Product.Name +'<small style="font-size: 14px">'+size+option+foodLabel(data.Product.Dietary)+custom+sub+'</small>'
}

export function toCurrencyFormat(numberString) {
    const number = parseFloat(numberString);
    return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2 // Added this line
    }).format(number);
}

export function foodLabel(array){
    let text = '';
    for(let i=0;i<array.length;i++){
        if(i+1===array.length){
            text = text + array[i].Name
        }else{
            text = text + array[i].Name+' - '
        }
    }
    if(text){
        return '('+ text+')';
    }else{
        return '';
    }

}
export function HasAccess(number, array) {
    return array?.includes(number);
}
